import {gql} from '@/api/types/__generated__';

export const VALID_EMAIL_ADDRESS = gql(`
    query validEmailAddress($emailAddress: String!) {
        validEmailAddress(emailAddress: $emailAddress)
    }
`);
